import React, { useEffect, useState } from "react";
import { LoginModal, useAuth } from "@dfds-platform/business-components";
import { EventEmitter } from "@angular/core";
import { OktaDetails } from "./okta.service";

interface Props {
    onSubmitted: EventEmitter<boolean>;
    onLoggingOut: EventEmitter<boolean>;
    onLoggedOut: EventEmitter<OktaDetails>;
    onLoggedIn: EventEmitter<OktaDetails>;
    onClose: EventEmitter<boolean>;
    onReady: EventEmitter<boolean>;
}

const OktaLogin = (props: Props) => {
    const [open, setOpen] = useState<boolean>(false);
    const [oktaLoaded, setOktaLoaded] = useState<boolean>(false);
    const { authApi, isLoggedIn, isAuthenticated, currentUser } = useAuth();

    const saveOktaDetails = async () => {
        const tokenDetails: TokenDetails = JSON.parse(sessionStorage.getItem('okta-token-storage'))
        const token = tokenDetails.oktaAccessToken.accessToken
        const sub = tokenDetails.oktaIdToken.claims.dfdsUserId

        localStorage.setItem('sbw_Token', token)
        localStorage.setItem('sbw_Sub', sub)
        localStorage.setItem('sbw_CurrentUser', JSON.stringify(currentUser))
    }

    useEffect(() => {
        props.onSubmitted.subscribe(_ => {
            setOpen(true);
        });

        props.onLoggingOut.subscribe(_ => {
            authApi.logout();
        });

        setOktaLoaded(true)
    }, []);

    useEffect(() => {
        if (oktaLoaded) {
            props.onReady.emit(true)
        }
    }, [oktaLoaded])

    useEffect(() => {
        if (isLoggedIn) {
            saveOktaDetails()
            props.onLoggedIn.emit({
                currentUser: currentUser,
                loggedIn: true,
            });
        }

        if (!isLoggedIn && oktaLoaded == true) {
            props.onLoggedOut.emit({
                currentUser: currentUser,
                loggedIn: false,
            });
        }
        setOpen(false);
    }, [isLoggedIn]);

    const oktaClose = () => {
        setOpen(false)
        props.onClose.emit()
    }

    return (
        <LoginModal
            sizes={{
                s: "fullscreen",
                m: "500px",
                l: "500px",
                xl: "500px",
                xxl: "500px",
            }}
            data-e2e="login-modal"
            modalOpen={open}
            preventClosing={authApi.isSubmitting}
            onModalClose={() => { oktaClose() }}
        ></LoginModal>
    );
};

export default OktaLogin;

export interface TokenDetails {
    oktaAccessToken: any
    oktaIdToken: any
}
